import { render, staticRenderFns } from "./Bonos.vue?vue&type=template&id=2cb3c783&scoped=true"
import script from "./Bonos.vue?vue&type=script&lang=js"
export * from "./Bonos.vue?vue&type=script&lang=js"
import style0 from "./Bonos.vue?vue&type=style&index=0&id=2cb3c783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3c783",
  null
  
)

export default component.exports